import { createContext, useContext } from 'react'
import { type SmartCallFlowBuilderStore } from '../store/SmartCallFlowBuilderStore'

export const SmartCallFlowBuilderContext = createContext<SmartCallFlowBuilderStore | null>(null)

export const useSmartCallFlowBuilderContext = () => {
  const context = useContext(SmartCallFlowBuilderContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with SmartCallFlowBuilderContext'
    )

  return context
}
